/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AllocatedPremiumScheduleByContractResponseDto,
  AllocatedPremiumScheduleListResponseDto,
  AvailableForAllocationOptionsResponseDto,
  ContractBalanceResponseDto,
  ErrorResponse,
  GetAllocatedPremiumScheduleQueryDto,
  GetPremiumDueBodyDto,
  GetPremiumScheduleAvailableForAllocationQueryDto,
  OriginalCurrencyForAllocationResponseDto,
  OriginalPremiumScheduleResponseDto,
  PremiumDueOptionsResponseDto,
  PremiumDuePaginationResponseDto,
  PremiumScheduleAvailableForAllocationListResponseDto,
  PremiumScheduleListResponseDto,
  UpdatePremiumSchedulePayloadDto,
} from '../models/index';
import {
    AllocatedPremiumScheduleByContractResponseDtoFromJSON,
    AllocatedPremiumScheduleByContractResponseDtoToJSON,
    AllocatedPremiumScheduleListResponseDtoFromJSON,
    AllocatedPremiumScheduleListResponseDtoToJSON,
    AvailableForAllocationOptionsResponseDtoFromJSON,
    AvailableForAllocationOptionsResponseDtoToJSON,
    ContractBalanceResponseDtoFromJSON,
    ContractBalanceResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetAllocatedPremiumScheduleQueryDtoFromJSON,
    GetAllocatedPremiumScheduleQueryDtoToJSON,
    GetPremiumDueBodyDtoFromJSON,
    GetPremiumDueBodyDtoToJSON,
    GetPremiumScheduleAvailableForAllocationQueryDtoFromJSON,
    GetPremiumScheduleAvailableForAllocationQueryDtoToJSON,
    OriginalCurrencyForAllocationResponseDtoFromJSON,
    OriginalCurrencyForAllocationResponseDtoToJSON,
    OriginalPremiumScheduleResponseDtoFromJSON,
    OriginalPremiumScheduleResponseDtoToJSON,
    PremiumDueOptionsResponseDtoFromJSON,
    PremiumDueOptionsResponseDtoToJSON,
    PremiumDuePaginationResponseDtoFromJSON,
    PremiumDuePaginationResponseDtoToJSON,
    PremiumScheduleAvailableForAllocationListResponseDtoFromJSON,
    PremiumScheduleAvailableForAllocationListResponseDtoToJSON,
    PremiumScheduleListResponseDtoFromJSON,
    PremiumScheduleListResponseDtoToJSON,
    UpdatePremiumSchedulePayloadDtoFromJSON,
    UpdatePremiumSchedulePayloadDtoToJSON,
} from '../models/index';

export interface FilterPremiumDueRequest {
    getPremiumDueBodyDto: GetPremiumDueBodyDto;
}

export interface GetAllocatedPremiumScheduleRequest {
    getAllocatedPremiumScheduleQueryDto: GetAllocatedPremiumScheduleQueryDto;
}

export interface GetAllocatedPremiumScheduleByContractIdRequest {
    contractId: string;
    currency?: string;
}

export interface GetAvailableForAllocationOptionsRequest {
    brokerId: string;
    currency: string;
}

export interface GetContractBalanceRequest {
    contractId: string;
    currency?: string;
}

export interface GetInstallmentDetailForContractRequest {
    contractId: string;
}

export interface GetOriginalCurrenciesForAllocationRequest {
    brokerId: string;
    settlementCurrency: GetOriginalCurrenciesForAllocationSettlementCurrencyEnum;
}

export interface GetOriginalPremiumScheduleRequest {
    contractId: string;
    currency?: string;
}

export interface GetPremiumScheduleAvailableForAllocationRequest {
    getPremiumScheduleAvailableForAllocationQueryDto: GetPremiumScheduleAvailableForAllocationQueryDto;
}

export interface UpdatePremiumScheduleRequest {
    premiumScheduleId: string;
    updatePremiumSchedulePayloadDto: UpdatePremiumSchedulePayloadDto;
}

/**
 * 
 */
export class PremiumScheduleApi extends runtime.BaseAPI {

    /**
     * Get premium due list
     */
    async filterPremiumDueRaw(requestParameters: FilterPremiumDueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PremiumDuePaginationResponseDto>> {
        if (requestParameters['getPremiumDueBodyDto'] == null) {
            throw new runtime.RequiredError(
                'getPremiumDueBodyDto',
                'Required parameter "getPremiumDueBodyDto" was null or undefined when calling filterPremiumDue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/filter-premium-due`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetPremiumDueBodyDtoToJSON(requestParameters['getPremiumDueBodyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PremiumDuePaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get premium due list
     */
    async filterPremiumDue(requestParameters: FilterPremiumDueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PremiumDuePaginationResponseDto> {
        const response = await this.filterPremiumDueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get allocated premium schedules by receipt ID
     */
    async getAllocatedPremiumScheduleRaw(requestParameters: GetAllocatedPremiumScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AllocatedPremiumScheduleListResponseDto>> {
        if (requestParameters['getAllocatedPremiumScheduleQueryDto'] == null) {
            throw new runtime.RequiredError(
                'getAllocatedPremiumScheduleQueryDto',
                'Required parameter "getAllocatedPremiumScheduleQueryDto" was null or undefined when calling getAllocatedPremiumSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/allocated`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAllocatedPremiumScheduleQueryDtoToJSON(requestParameters['getAllocatedPremiumScheduleQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AllocatedPremiumScheduleListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get allocated premium schedules by receipt ID
     */
    async getAllocatedPremiumSchedule(requestParameters: GetAllocatedPremiumScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AllocatedPremiumScheduleListResponseDto> {
        const response = await this.getAllocatedPremiumScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get allocated premium schedules by contract ID
     */
    async getAllocatedPremiumScheduleByContractIdRaw(requestParameters: GetAllocatedPremiumScheduleByContractIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AllocatedPremiumScheduleByContractResponseDto>>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getAllocatedPremiumScheduleByContractId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currency'] != null) {
            queryParameters['currency'] = requestParameters['currency'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/contract/{contractId}/allocated`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AllocatedPremiumScheduleByContractResponseDtoFromJSON));
    }

    /**
     * Get allocated premium schedules by contract ID
     */
    async getAllocatedPremiumScheduleByContractId(requestParameters: GetAllocatedPremiumScheduleByContractIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AllocatedPremiumScheduleByContractResponseDto>> {
        const response = await this.getAllocatedPremiumScheduleByContractIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get available options for available for allocation filtering
     */
    async getAvailableForAllocationOptionsRaw(requestParameters: GetAvailableForAllocationOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AvailableForAllocationOptionsResponseDto>> {
        if (requestParameters['brokerId'] == null) {
            throw new runtime.RequiredError(
                'brokerId',
                'Required parameter "brokerId" was null or undefined when calling getAvailableForAllocationOptions().'
            );
        }

        if (requestParameters['currency'] == null) {
            throw new runtime.RequiredError(
                'currency',
                'Required parameter "currency" was null or undefined when calling getAvailableForAllocationOptions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currency'] != null) {
            queryParameters['currency'] = requestParameters['currency'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/available-for-allocation/options/{brokerId}`.replace(`{${"brokerId"}}`, encodeURIComponent(String(requestParameters['brokerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AvailableForAllocationOptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get available options for available for allocation filtering
     */
    async getAvailableForAllocationOptions(requestParameters: GetAvailableForAllocationOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AvailableForAllocationOptionsResponseDto> {
        const response = await this.getAvailableForAllocationOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contract balance for unallocated premium schedules
     */
    async getContractBalanceRaw(requestParameters: GetContractBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractBalanceResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getContractBalance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currency'] != null) {
            queryParameters['currency'] = requestParameters['currency'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/contract/{contractId}/balance`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractBalanceResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contract balance for unallocated premium schedules
     */
    async getContractBalance(requestParameters: GetContractBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractBalanceResponseDto> {
        const response = await this.getContractBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get installment detail for contract
     */
    async getInstallmentDetailForContractRaw(requestParameters: GetInstallmentDetailForContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PremiumScheduleListResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getInstallmentDetailForContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PremiumScheduleListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get installment detail for contract
     */
    async getInstallmentDetailForContract(requestParameters: GetInstallmentDetailForContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PremiumScheduleListResponseDto> {
        const response = await this.getInstallmentDetailForContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get original currencies for premium schedules available for allocation
     */
    async getOriginalCurrenciesForAllocationRaw(requestParameters: GetOriginalCurrenciesForAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OriginalCurrencyForAllocationResponseDto>>> {
        if (requestParameters['brokerId'] == null) {
            throw new runtime.RequiredError(
                'brokerId',
                'Required parameter "brokerId" was null or undefined when calling getOriginalCurrenciesForAllocation().'
            );
        }

        if (requestParameters['settlementCurrency'] == null) {
            throw new runtime.RequiredError(
                'settlementCurrency',
                'Required parameter "settlementCurrency" was null or undefined when calling getOriginalCurrenciesForAllocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['brokerId'] != null) {
            queryParameters['brokerId'] = requestParameters['brokerId'];
        }

        if (requestParameters['settlementCurrency'] != null) {
            queryParameters['settlementCurrency'] = requestParameters['settlementCurrency'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/available-for-allocation/original-currencies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OriginalCurrencyForAllocationResponseDtoFromJSON));
    }

    /**
     * Get original currencies for premium schedules available for allocation
     */
    async getOriginalCurrenciesForAllocation(requestParameters: GetOriginalCurrenciesForAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OriginalCurrencyForAllocationResponseDto>> {
        const response = await this.getOriginalCurrenciesForAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get original premium schedule
     */
    async getOriginalPremiumScheduleRaw(requestParameters: GetOriginalPremiumScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OriginalPremiumScheduleResponseDto>>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getOriginalPremiumSchedule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currency'] != null) {
            queryParameters['currency'] = requestParameters['currency'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/contract/{contractId}/original-premium-schedule`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OriginalPremiumScheduleResponseDtoFromJSON));
    }

    /**
     * Get original premium schedule
     */
    async getOriginalPremiumSchedule(requestParameters: GetOriginalPremiumScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OriginalPremiumScheduleResponseDto>> {
        const response = await this.getOriginalPremiumScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get available options for premium due filtering
     */
    async getPremiumDueOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PremiumDueOptionsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/due/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PremiumDueOptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get available options for premium due filtering
     */
    async getPremiumDueOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PremiumDueOptionsResponseDto> {
        const response = await this.getPremiumDueOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get premium schedules available for allocation
     */
    async getPremiumScheduleAvailableForAllocationRaw(requestParameters: GetPremiumScheduleAvailableForAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PremiumScheduleAvailableForAllocationListResponseDto>> {
        if (requestParameters['getPremiumScheduleAvailableForAllocationQueryDto'] == null) {
            throw new runtime.RequiredError(
                'getPremiumScheduleAvailableForAllocationQueryDto',
                'Required parameter "getPremiumScheduleAvailableForAllocationQueryDto" was null or undefined when calling getPremiumScheduleAvailableForAllocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/available-for-allocation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetPremiumScheduleAvailableForAllocationQueryDtoToJSON(requestParameters['getPremiumScheduleAvailableForAllocationQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PremiumScheduleAvailableForAllocationListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get premium schedules available for allocation
     */
    async getPremiumScheduleAvailableForAllocation(requestParameters: GetPremiumScheduleAvailableForAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PremiumScheduleAvailableForAllocationListResponseDto> {
        const response = await this.getPremiumScheduleAvailableForAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update premium schedule
     */
    async updatePremiumScheduleRaw(requestParameters: UpdatePremiumScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdatePremiumSchedulePayloadDto>> {
        if (requestParameters['premiumScheduleId'] == null) {
            throw new runtime.RequiredError(
                'premiumScheduleId',
                'Required parameter "premiumScheduleId" was null or undefined when calling updatePremiumSchedule().'
            );
        }

        if (requestParameters['updatePremiumSchedulePayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updatePremiumSchedulePayloadDto',
                'Required parameter "updatePremiumSchedulePayloadDto" was null or undefined when calling updatePremiumSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/premium-schedule/{premiumScheduleId}`.replace(`{${"premiumScheduleId"}}`, encodeURIComponent(String(requestParameters['premiumScheduleId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePremiumSchedulePayloadDtoToJSON(requestParameters['updatePremiumSchedulePayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePremiumSchedulePayloadDtoFromJSON(jsonValue));
    }

    /**
     * Update premium schedule
     */
    async updatePremiumSchedule(requestParameters: UpdatePremiumScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdatePremiumSchedulePayloadDto> {
        const response = await this.updatePremiumScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetOriginalCurrenciesForAllocationSettlementCurrencyEnum = {
    Aud: 'AUD',
    Usd: 'USD',
    Nzd: 'NZD'
} as const;
export type GetOriginalCurrenciesForAllocationSettlementCurrencyEnum = typeof GetOriginalCurrenciesForAllocationSettlementCurrencyEnum[keyof typeof GetOriginalCurrenciesForAllocationSettlementCurrencyEnum];
